'use strict'

import { diaChi, dichCung, khoangCachCung, thienCan } from './amduong'

export class CungDiaBan {
  constructor (cungID) {
    var hanhCung = [null, 'thuy', 'tho', 'moc', 'moc', 'tho', 'hoa',
      'hoa', 'tho', 'kim', 'kim', 'tho', 'thuy']
    this.cungSo = cungID
    this.hanhCung = hanhCung[cungID]
    this.cungSao = []
    this.cungAmDuong = (this.cungSo % 2 === 0) ? -1 : 1
    this.cungTen = diaChi[this.cungSo].tenChi
    this.cungThan = false
    this.cungTuHoa = []
    this.cungTuHoa2 = []
  }

  anCungCan (canId) {
    this.cungCanId = canId
    this.cungCan = thienCan[canId].chuCaiDau
    return this
  }

  themSao (sao) {
    dacTinhSao(this.cungSo, sao)
    this.cungSao.push(sao)
    return this
  }

  themTuHoa (sao) {
    this.cungTuHoa.push(sao)
    return this
  }

  themTuHoa2 (sao) {
    const getCung = this.cungTuHoa2.findIndex((item) => item.saoID === sao.saoID)
    let tmpSao
    // da co
    if (getCung !== -1) {
      tmpSao = {
        ...sao,
        viTriCp: [...this.cungTuHoa2[getCung].viTriCp, sao.viTriCp]
      }
      this.cungTuHoa2[getCung] = tmpSao
    } else {
      tmpSao = {
        ...sao,
        viTriCp: [sao.viTriCp]
      }
      this.cungTuHoa2.push(tmpSao)
    }
    return this
  }

  setCungChu (tenCungChu) {
    this.cungChu = tenCungChu
    return this
  }

  setCungChuShort (tenCungChuShort) {
    this.cungChuShort = tenCungChuShort
    return this
  }

  daiHan (daiHan) {
    this.cungDaiHan = daiHan
    return this
  }

  tieuHan (tieuHan) {
    this.cungTieuHan = diaChi[tieuHan + 1].tenChi
    return this
  }

  thangHan (thangHan) {
    this.cungThangHan = thangHan + 1
    return this
  }

  anCungThan () {
    this.cungThan = true
    return this
  }

  anTuan () {
    this.tuanTrung = true
    return this
  }

  anTriet () {
    this.trietLo = true
    return this
  }

  anTuanDv () {
    this.tuanTrungDv = true
    return this
  }

  anTrietDv () {
    this.trietLoDv = true
    return this
  }
}

export class DiaBan {
  constructor (thangSinhAmLich, gioSinhAmLich, canchiNamXem, curTuoi, curYear, daiHanXem) {
    this.thangSinhAmLich = thangSinhAmLich
    this.gioSinhAmLich = gioSinhAmLich
    this.canchiNamXem = canchiNamXem
    this.curTuoi = curTuoi
    this.curYear = curYear
    this.daiHanXem = daiHanXem
    this.thapNhiCung = []
    for (var i = 0, j = 13; (i < j); i += 1) {
      this.thapNhiCung.push(new CungDiaBan(i))
    }
    this.nhapCungChu()
    this.nhapCungThan()
  }

  cungChu (thangSinhAmLich, gioSinhAmLich) {
    this.cungThan = dichCung(3, thangSinhAmLich - 1, gioSinhAmLich - 1)
    this.cungMenh = dichCung(3, thangSinhAmLich - 1, -(gioSinhAmLich) + 1)
    var cungPhuMau = dichCung(this.cungMenh, 1)
    var cungPhucDuc = dichCung(this.cungMenh, 2)
    var cungDienTrach = dichCung(this.cungMenh, 3)
    var cungQuanLoc = dichCung(this.cungMenh, 4)
    this.cungNoboc = dichCung(this.cungMenh, 5) // Để an sao Thiên thương
    var cungThienDi = dichCung(this.cungMenh, 6)
    this.cungTatAch = dichCung(this.cungMenh, 7) // an sao Thiên sứ
    var cungTaiBach = dichCung(this.cungMenh, 8)
    var cungTuTuc = dichCung(this.cungMenh, 9)
    var cungTheThiep = dichCung(this.cungMenh, 10)
    var cungHuynhDe = dichCung(this.cungMenh, 11)

    return [
      {
        cungId: 1,
        tenCung: 'Mệnh',
        tenCungShort: 'Mệnh',
        cungSoDiaBan: this.cungMenh
      },
      {
        cungId: 2,
        tenCung: 'Phụ Mẫu',
        tenCungShort: 'Phụ',
        cungSoDiaBan: cungPhuMau

      },
      {
        cungId: 3,
        tenCung: 'Phúc Đức',
        tenCungShort: 'Phúc',
        cungSoDiaBan: cungPhucDuc

      },
      {
        cungId: 4,
        tenCung: 'Điền Trạch',
        tenCungShort: 'Điền',
        cungSoDiaBan: cungDienTrach

      },
      {
        cungId: 5,
        tenCung: 'Quan Lộc',
        tenCungShort: 'Quan',
        cungSoDiaBan: cungQuanLoc

      },
      {
        cungId: 6,
        tenCung: 'Nô Bộc',
        tenCungShort: 'Nô',
        cungSoDiaBan: this.cungNoboc

      },
      {
        cungId: 7,
        tenCung: 'Thiên Di',
        tenCungShort: 'Di',
        cungSoDiaBan: cungThienDi

      },
      {
        cungId: 8,
        tenCung: 'Tật Ách',
        tenCungShort: 'Tật',
        cungSoDiaBan: this.cungTatAch

      },
      {
        cungId: 9,
        tenCung: 'Tài Bạch',
        tenCungShort: 'Tài',
        cungSoDiaBan: cungTaiBach

      },
      {
        cungId: 10,
        tenCung: 'Tử Tức',
        tenCungShort: 'Tử',
        cungSoDiaBan: cungTuTuc

      },
      {
        cungId: 11,
        tenCung: 'Phu Thê',
        tenCungShort: 'Phối',
        cungSoDiaBan: cungTheThiep

      },
      {
        cungId: 12,
        tenCung: 'Huynh Đệ',
        tenCungShort: 'Huynh',
        cungSoDiaBan: cungHuynhDe

      }
    ]
  }

  nhapCungChu () {
    var cungChu = this.cungChu(this.thangSinhAmLich, this.gioSinhAmLich)
    for (var index in cungChu) {
      // eslint-disable-next-line no-prototype-builtins
      if (cungChu.hasOwnProperty(index)) {
        var cung = cungChu[index]
        this.thapNhiCung[cung.cungSoDiaBan].setCungChu(cung.tenCung)
        this.thapNhiCung[cung.cungSoDiaBan].setCungChuShort(cung.tenCungShort)
      }
    }
    return this
  }

  nhapDaiHan (cucSo, gioiTinh) {
    var thapNhiCung = this.thapNhiCung
    for (var index in thapNhiCung) {
      // eslint-disable-next-line no-prototype-builtins
      if (thapNhiCung.hasOwnProperty(index)) {
        var cung = thapNhiCung[index]
        var khoangCach = khoangCachCung(cung.cungSo, this.cungMenh, gioiTinh)
        cung.daiHan(cucSo + khoangCach * 10)
      }
    }

    const curSoDaiHan = Object.values(thapNhiCung)
      .sort((a, b) => (a.cungDaiHan < b.cungDaiHan) ? 1 : -1)
      .find((item) => item.cungDaiHan <= this.curTuoi, {})

    this.curSoDaiHan = curSoDaiHan ? curSoDaiHan.cungSo : null
    return this
  }

  nhapTieuHan (khoiTieuHan, gioiTinh, chiNam) {
    // Vị trí khởi tiểu Hạn là của năm sinh theo chi
    // vì vậy cần phải tìm vị trí cung Tý của năm đó
    var viTriCungTy1 = dichCung(khoiTieuHan, -gioiTinh * (chiNam - 1))

    // Tiếp đó là nhập hạn
    var thapNhiCung = this.thapNhiCung
    for (var index in thapNhiCung) {
      // eslint-disable-next-line no-prototype-builtins
      if (thapNhiCung.hasOwnProperty(index)) {
        var cung = thapNhiCung[index]
        var khoangCach = khoangCachCung(cung.cungSo, viTriCungTy1, gioiTinh)
        cung.tieuHan(khoangCach)
      }
    }
    return this
  }

  nhapThangHan (khoiTieuHan, gioiTinh, chiNam, chiNamXem, thangSinh, gioSinh) {
    // Vị trí khởi là của năm sinh theo chi
    // vì vậy cần phải tìm vị trí cung Tý của năm đó
    // chinh la vi tri nam ty cua tieu han
    var viTriCungTy1 = dichCung(khoiTieuHan, -gioiTinh * (chiNam - 1))

    // tiếp đó là đếm ngược tới tháng sinh và đếm thuận tới giờ sinh
    var vitriThang1 = dichCung(viTriCungTy1, gioiTinh * (chiNamXem - 1) - (thangSinh - 1) + gioSinh + 1)

    // Tiếp đó là nhập hạn
    var thapNhiCung = this.thapNhiCung
    for (var index in thapNhiCung) {
      // eslint-disable-next-line no-prototype-builtins
      if (thapNhiCung.hasOwnProperty(index)) {
        var cung = thapNhiCung[index]
        var khoangCach = khoangCachCung(cung.cungSo, vitriThang1, 1)
        cung.thangHan(khoangCach)
      }
    }
    return this
  }

  nhapCungThan () {
    this.thapNhiCung[this.cungThan].anCungThan()
  }

  nhapCungCan (canNam) {
    // khoi vi tri dau theo ngu ho don
    let khoiCan
    if ([1, 6].includes(canNam)) {
      khoiCan = 3
    } else if ([2, 7].includes(canNam)) {
      khoiCan = 5
    } else if ([3, 8].includes(canNam)) {
      khoiCan = 7
    } else if ([4, 9].includes(canNam)) {
      khoiCan = 9
    } else if ([5, 10].includes(canNam)) {
      khoiCan = 1
    }

    var thapNhiCung = this.thapNhiCung
    for (var index in thapNhiCung) {
      // eslint-disable-next-line no-prototype-builtins
      if (thapNhiCung.hasOwnProperty(index)) {
        var cung = thapNhiCung[index]
        var k1 = (cung.cungSo - 2 + 12) % 12
        k1 = k1 === 0 ? 12 : k1
        var khoangCach = (k1 + khoiCan - 1) % 10
        khoangCach = khoangCach === 0 ? 10 : khoangCach
        if (cung.cungSo > 0) {
          this.thapNhiCung[cung.cungSo].anCungCan(khoangCach)
        }
      }
    }
    return this
  }

  nhapSao (diaBan, cungSo, ...args) {
    for (var index in args) {
      const sao = args[index]
      this.thapNhiCung[cungSo > 0 ? cungSo : 0].themSao(sao)
    }
    return this
  }

  nhapTuHoa (diaBan, cungSo, ...args) {
    for (var index in args) {
      const sao = args[index]
      this.thapNhiCung[cungSo > 0 ? cungSo : 0].themTuHoa(sao)
    }
    return this
  }

  nhapTuHoa2 (diaBan, cungSo, ...args) {
    for (var index in args) {
      const sao = args[index]
      this.thapNhiCung[cungSo > 0 ? cungSo : 0].themTuHoa2(sao)
    }
    return this
  }

  nhapPathTuHoaLoc (path) {
    this.pathTuHoaLoc = path
    return this
  }

  nhapPathTuHoaKy (path) {
    this.pathTuHoaKy = path
    return this
  }

  nhapPathTuHoaQuyen (path) {
    this.pathTuHoaQuyen = path
    return this
  }

  nhapPathTuHoaKhoa (path) {
    this.pathTuHoaKhoa = path
    return this
  }

  nhapLineMenh (value) {
    this.lineMenh = value
    return this
  }

  nhapLineMenhPhu (value) {
    this.lineMenhPhu = value
    return this
  }

  nhapTuan (...args) {
    for (var index in args) {
      const cung = args[index]
      this.thapNhiCung[cung].anTuan()
    }
    return this
  }

  nhapTriet (...args) {
    for (var index in args) {
      const cung = args[index]
      this.thapNhiCung[cung].anTriet()
    }
    return this
  }

  nhapTuanDv (...args) {
    for (var index in args) {
      const cung = args[index]
      this.thapNhiCung[cung].anTuanDv()
    }
    return this
  }

  nhapTrietDv (...args) {
    for (var index in args) {
      const cung = args[index]
      this.thapNhiCung[cung].anTrietDv()
    }
    return this
  }
}

function dacTinhSao (viTriDiaBan, sao) {
  var maTranDacTinh = {

    1: ['Tử vi', 'B', 'Đ', 'M', 'B', 'V', 'M', 'M', 'Đ', 'M', 'B', 'V', 'B'],
    2: ['Liêm trinh', 'V', 'Đ', 'V', 'H', 'M', 'H', 'V', 'Đ', 'V', 'H', 'M', 'H'],
    3: ['Thiên đồng', 'V', 'H', 'M', 'Đ', 'H', 'Đ', 'H', 'H', 'M', 'H', 'H', 'Đ'],
    4: ['Vũ khúc', 'V', 'M', 'V', 'Đ', 'M', 'H', 'V', 'M', 'V', 'Đ', 'M', 'H'],
    5: ['Thái dương', 'H', 'Đ', 'V', 'V', 'V', 'M', 'M', 'Đ', 'H', 'H', 'H', 'H'],
    6: ['Thiên cơ', 'Đ', 'Đ', 'H', 'M', 'M', 'V', 'Đ', 'Đ', 'V', 'M', 'M', 'H'],
    7: ['Thiên phủ', 'M', 'B', 'M', 'B', 'V', 'Đ', 'M', 'Đ', 'M', 'B', 'V', 'Đ'],
    8: ['Thái âm', 'V', 'Đ', 'H', 'H', 'H', 'H', 'H', 'Đ', 'V', 'M', 'M', 'M'],
    9: ['Tham lang', 'H', 'M', 'Đ', 'H', 'V', 'H', 'H', 'M', 'Đ', 'H', 'V', 'H'],
    10: ['Cự môn', 'V', 'H', 'V', 'M', 'H', 'H', 'V', 'H', 'Đ', 'M', 'H', 'Đ'],
    11: ['Thiên tướng', 'V', 'Đ', 'M', 'H', 'V', 'Đ', 'V', 'Đ', 'M', 'H', 'V', 'Đ'],
    12: ['Thiên lương', 'V', 'Đ', 'V', 'V', 'M', 'H', 'M', 'Đ', 'V', 'H', 'M', 'H'],
    13: ['Thất sát', 'M', 'Đ', 'M', 'H', 'H', 'V', 'M', 'Đ', 'M', 'H', 'H', 'V'],
    14: ['Phá quân', 'M', 'V', 'H', 'H', 'Đ', 'H', 'M', 'V', 'H', 'H', 'Đ', 'H'],
    27: ['Lộc tồn', 'M', 'null', 'M', 'M', 'null', 'Đ', 'M', 'null', 'B', 'B', 'null', 'Đ'],
    51: ['Đà la', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H'],
    52: ['Kình dương', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H'],
    55: ['Linh tinh', 'H', 'H', 'Đ', 'Đ', 'Đ', 'Đ', 'Đ', 'H', 'H', 'H', 'H', 'H'],
    56: ['Hỏa tinh', 'H', 'H', 'Đ', 'Đ', 'Đ', 'Đ', 'Đ', 'H', 'H', 'H', 'H', 'H'],
    57: ['Văn xương', 'H', 'Đ', 'H', 'Đ', 'Đ', 'Đ', 'H', 'Đ', 'H', 'H', 'Đ', 'Đ'],
    58: ['Văn khúc', 'H', 'Đ', 'H', 'Đ', 'Đ', 'Đ', 'H', 'Đ', 'H', 'H', 'Đ', 'Đ'],
    53: ['Địa không', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'Đ'],
    54: ['Địa kiếp', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'Đ'],
    92: ['Hóa khoa', 'Đ', 'V', 'Đ', 'Đ', 'V', 'Đ', 'B', 'Đ', 'Đ', 'Đ', 'V', 'Đ'],
    93: ['Hóa quyền', 'B', 'V', 'Đ', 'V', 'Đ', 'Đ', 'Đ', 'Đ', 'B', 'Đ', 'V', 'Đ'],
    94: ['Hóa lộc', 'B', 'V', 'Đ', 'Đ', 'V', 'Đ', 'B', 'Đ', 'Đ', 'Đ', 'V', 'Đ'],
    95: ['Hóa kỵ', 'H', 'B', 'H', 'H', 'B', 'H', 'H', 'Đ', 'H', 'H', 'B', 'H'],
    36: ['Đại hao', 'H', 'H', 'Đ', 'Đ', 'H', 'H', 'H', 'H', 'Đ', 'Đ', 'H', 'H'],
    30: ['Tiểu Hao', 'H', 'H', 'Đ', 'Đ', 'H', 'H', 'H', 'H', 'Đ', 'Đ', 'H', 'H'],
    69: ['Thiên khốc', 'Đ', 'Đ', 'H', 'Đ', 'H', 'H', 'Đ', 'Đ', 'H', 'Đ', 'H', 'H'],
    70: ['Thiên hư', 'Đ', 'Đ', 'H', 'Đ', 'H', 'H', 'Đ', 'Đ', 'H', 'Đ', 'H', 'H'],
    98: ['Thiên mã', 'H', 'H', 'Đ', 'H', 'H', 'Đ', 'H', 'H', 'H', 'H', 'H', 'H'],
    73: ['Thiên Hình', 'H', 'H', 'Đ', 'Đ', 'H', 'H', 'H', 'H', 'Đ', 'Đ', 'H', 'H'],
    74: ['Thiên riêu', 'H', 'H', 'Đ', 'Đ', 'H', 'H', 'H', 'H', 'H', 'Đ', 'Đ', 'H']
  }
  if (Object.keys(maTranDacTinh).includes(sao.saoID.toString())) {
    if (['M', 'V', 'Đ', 'B', 'H'].includes(maTranDacTinh[sao.saoID][viTriDiaBan])) {
      sao.anDacTinh(maTranDacTinh[sao.saoID][viTriDiaBan])
    }
  }
}
